import BaseModelAPI from '../BaseModelAPI';

export default class DelegationSetting extends BaseModelAPI {
	static entity = 'delegationsetting';
	static entityName = 'delegationsetting';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.delegateFrom = '';
			this.delegateTo = '';
			this.periodFrom = '';
			this.periodTo = '';
			this.isAllTime = false;
			this.remarks = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}